var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.rules,
                model: _vm.formData,
                "label-width": "130px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "提现初始人数：", prop: "cashInitUserNum" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 1,
                      "controls-position": "right",
                      "step-strictly": "",
                      placeholder: "请输入提现初始人数",
                    },
                    model: {
                      value: _vm.formData.cashInitUserNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "cashInitUserNum", $$v)
                      },
                      expression: "formData.cashInitUserNum",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "每日提现人数上限：",
                    prop: "cashLimitDaily",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 1,
                      "controls-position": "right",
                      "step-strictly": "",
                      placeholder: "请输入提现人数上限",
                    },
                    model: {
                      value: _vm.formData.cashLimitDaily,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "cashLimitDaily", $$v)
                      },
                      expression: "formData.cashLimitDaily",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("控制每日提现用户的总人数"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "提现公众号APPID：",
                    prop: "wechatPublicAppid",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入提现公众号appid",
                    },
                    model: {
                      value: _vm.formData.wechatPublicAppid,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "wechatPublicAppid",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.wechatPublicAppid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "提现公众号密钥：",
                    prop: "wechatPublicAppSecret",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入提现公众号密钥" },
                    model: {
                      value: _vm.formData.wechatPublicAppSecret,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "wechatPublicAppSecret",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.wechatPublicAppSecret",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客服：", prop: "popupId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择客服",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.popupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "popupId", $$v)
                        },
                        expression: "formData.popupId",
                      },
                    },
                    _vm._l(_vm.qrcodeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.pageName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客服按钮文案：", prop: "popupDes" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "4",
                      "show-word-limit": "",
                      placeholder: "请输入客服按钮文案",
                    },
                    model: {
                      value: _vm.formData.popupDes,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "popupDes",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.popupDes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告ID：", prop: "advId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择广告",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.advId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "advId", $$v)
                        },
                        expression: "formData.advId",
                      },
                    },
                    _vm._l(_vm.advList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.adName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动说明：", prop: "cashDes" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "500px" } },
                    [
                      _c("Tinymce", {
                        model: {
                          value: _vm.formData.cashDes,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "cashDes", $$v)
                          },
                          expression: "formData.cashDes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:user:withdraw:config:update",
                          ],
                          expression:
                            "['platform:system:user:withdraw:config:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }